const setLinkForResults = (data: any) => {
  return data.map((item: any) => ({
    ...item,
    to: { name: 'event-card', params: { id: item.id, code: item.code } },
    img: { small: item.image.small, large: item.image.large },
  }));
};

export default setLinkForResults;



// WEBPACK FOOTER //
// ./src/services/cabinet/utils/setLinkForResults.ts